import * as actionTypes from "../constants/actionTypes";
import * as modules from "../constants/modules";
import * as license from "../constants/license";
import * as getterHelper from "../helpers/getterHelper";
import * as windowService from "../services/windowService";
import * as changelogService from "../services/changelogService";

import PluginManager from "../models/PluginManager";

const initialState = {
    software: "Redlike Client",
    softwareCode: "redlike_client",
    softwareStyle: windowService.getSoftwareStyle(),
    name: windowService.getModule(),
    softwareType: windowService.getSoftwareType(),
    softwareVersion: changelogService.getLastClientVersion(),
    softwareRevision:
        windowService.getBuildRevision() === null
            ? changelogService.getLastClientRevision()
            : windowService.getBuildRevision(),
    buildVersion: windowService.getBuildVersion(),
    setupSoftware: windowService.getBasicSetup() === false,
    redlikeSoftware: windowService.getSoftwareType() === modules.SOFTWARE_REDLIKE,
    redlikeLightSoftware:
        windowService.getSoftwareType() === modules.SOFTWARE_LIGHT ||
        windowService.getSoftwareType() === modules.SOFTWARE_WEBER ||
        windowService.getLightAtStartup(),
    gammaSoftware: !windowService.getLightAtStartup() && windowService.getSoftwareType() === modules.SOFTWARE_GAMMA,
    weberSoftware: windowService.getSoftwareType() === modules.SOFTWARE_WEBER,
    colorisSoftware: windowService.getSoftwareType() === modules.SOFTWARE_COLORIS,
    productOne: false,
    productPricing: false,
    productEntry: false,
    productDispensingManual: false,
    productDispensing: false,
    productPlus: false,
    rccModule: false,
    printerTemplateEditor: windowService.isPrintTemplateEditorAvailable(),
    clientIdentifier: windowService.getClientIdentifier(),
    plugins: new PluginManager(windowService.getPlugins()),
    modules: []
};

/**
 * Structure of module store:
 * - software {String}          - readable name of software
 * - softwareCode {String}      - software identification code
 * - softwareStyle {String}     - basic software style (Redlike, Light, Gamma...)
 * - softwareVersion {String}   - version of software
 * - softwareRevision {String}  - developer version of software
 * - name {String}              - active software module
 * - buildVersion {String}      - build version
 * - redlikeSoftware {Boolean}
 * - redlikeLightSoftware {Boolean}
 * - gammaSoftware {Boolean}
 * - weberSoftware {Boolean}
 * - productOne {Boolean}
 * - productPricing {Boolean}
 * - productEntry {Boolean}
 * - productDispensing {Boolean}
 * - productDispensingManual {Boolean}
 * - productPlus {Boolean}
 * - rccModule {Boolean}                - If true, RCC module is available
 * - printerTemplateEditor {Boolean}    - If true, RedlikePrintTemplateEditor.exe is available on local PC
 * - clientIdentifier {String}          - client identification
 * - plugins {Object}                   - provides configuration of supported plugins
 * - modules {Array}                    - list of licensed modules
 */
export const moduleReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SAVE_MODULE:
            return {
                ...state,
                name: action.payload.module
            };
        case actionTypes.CHANGE_MODULE:
            return {
                ...state,
                name: action.payload.module
            };
        case actionTypes.CHANGE_SOFTWARE_TYPE:
            return {
                ...state,
                softwareStyle: getterHelper.getStyleBySoftware(action.payload.type),
                redlikeSoftware: action.payload.type === modules.SOFTWARE_REDLIKE,
                redlikeLightSoftware: action.payload.type === modules.SOFTWARE_LIGHT,
                gammaSoftware: action.payload.type === modules.SOFTWARE_GAMMA
            };
        case actionTypes.SERVER_IS_LICENSED:
        case actionTypes.SERVER_IS_LICENSED_COMPACT:
            return {
                ...state,
                rccModule: action.payload.modules.some((module) => module === modules.MODULE_RCC),
                productOne: action.payload.product === license.PRODUCT_ONE,
                productPricing:
                    action.payload.product === license.PRODUCT_ONE ||
                    action.payload.product === license.PRODUCT_PRICING,
                productEntry: action.payload.product === license.PRODUCT_ENTRY,
                productDispensingManual: action.payload.product === license.PRODUCT_DISPENSING_MANUAL,
                productDispensing: action.payload.product === license.PRODUCT_DISPENSING,
                productPlus: action.payload.product === license.PRODUCT_PLUS,
                modules: action.payload.licenseModules
            };
        case actionTypes.SET_CLIENT_IDENTIFIER:
            return {
                ...state,
                clientIdentifier: action.payload.clientIdentifier
            };
        case actionTypes.PLUGINS_SET_WINTER:
            return {
                ...state,
                plugins: state.plugins.updateWinterPlugin(action.payload.active)
            };
        case actionTypes.PLUGINS_RELOAD_WINTER_TIME:
            return {
                ...state,
                plugins: state.plugins.updateWinterTimePlugin()
            };
        case actionTypes.SETUP_COMPLETED:
            let result = windowService.setBasicSetup(true);

            if (!result) {
                return state;
            }

            return {
                ...state,
                setupSoftware: false
            };
        default:
            return state;
    }
};
